export class EventStorageOpenedHandler {
    // eslint-disable-next-line class-methods-use-this
    public handle(): void {
        const chatIcon = $('#minimized_chat');
        chatIcon.css('display', 'none');
    }
}
